"use client";

import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import Launch from "@/components/icons/Launch";
import getCourseRunTilePrimaryText from "@/lib/course/utils/getCourseRunTilePrimaryText";
import { CourseRun } from "@/common/courseRun/types";

type PopoverComponentProps = {
  courseRun?: CourseRun;
  enrollButtonLink: URL | string;
  onStickyNav?: boolean;
};

export default function ExecEdEnrollButton({
  courseRun,
  enrollButtonLink,
  onStickyNav,
}: PopoverComponentProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger asChild>
        <a
          className="text-white font-semibold bg-brand w-full min-h-11 md:w-auto rounded-md px-4 border-2 border-brand hover:bg-white hover:text-brand"
          onMouseEnter={() => setIsPopoverOpen(true)}
          onMouseLeave={() => setIsPopoverOpen(false)}
          href={enrollButtonLink.toString()}
          style={{ outline: "none" }}
          target="_blank"
        >
          <div
            className={`inline-block text-sm md:text-base px-4 ${onStickyNav ? "" : "py-2"}`}
          >
            <div className="flex flex-col items-center">
              <span className="m-0 flex">
                Enroll now&nbsp;
                <Launch svgProps={{ width: "24", height: "24" }} />
              </span>
              {courseRun && (
                <div className="text-sm">
                  {getCourseRunTilePrimaryText(courseRun)}
                </div>
              )}
            </div>
          </div>
        </a>
      </PopoverTrigger>
      <PopoverContent className="bg-primary p-4 rounded-xl max-w-56 mx-auto text-white text-sm text-center">
        You will be taken to GetSmarter in the current tab.
      </PopoverContent>
    </Popover>
  );
}
